import api from '../config/api';

const tableService = {
  async getShopTables() {
    try {
      const response = await api.get('/shop/tables');
      return { success: true, data: response.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to fetch tables' 
      };
    }
  },

  async createTables(count) {
    try {
      const response = await api.post('/shop/tables/bulk', { count });
      return { success: true, data: response.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to create tables' 
      };
    }
  },

  async generateQRCode(tableId) {
    try {
      const response = await api.get(`/shop/tables/${tableId}/qr`);
      return { success: true, data: response.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to generate QR code' 
      };
    }
  },

  async getTableQRImage(tableId) {
    try {
      const response = await api.get(`/shop/tables/${tableId}/qr-image`, {
        responseType: 'arraybuffer'
      });
      return { success: true, data: response.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to get QR image' 
      };
    }
  },

  async getTableQRImageClassic(tableId) {
    try {
      const response = await api.get(`/shop/tables/${tableId}/qr-image/classic`, {
        responseType: 'arraybuffer'
      });
      return { success: true, data: response.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to get classic QR image' 
      };
    }
  },

  async getTableQRImageCustom(tableId, size = 300, includeLogo = true) {
    try {
      const response = await api.get(`/shop/tables/${tableId}/qr-image/custom`, {
        params: { size, includeLogo },
        responseType: 'arraybuffer'
      });
      return { success: true, data: response.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to get custom QR image' 
      };
    }
  },

  async deleteTable(tableId) {
    try {
      await api.delete(`/shop/tables/${tableId}`);
      return { success: true };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to delete table' 
      };
    }
  }
};

export default tableService; 